// Centralizes the postMessage format for ExpressCheckout callbacks.
// The event name contract is stable and partner-facing:
//   callback-payabli-function-expresscheckout-<kind><randomId>
//
// kinds: "success" | "error" | "cancel" | "resize" | "set-token"
//
// Keeping this in one place guarantees all wallets emit the exact same
// shape and lets us snapshot-test the contract in a single suite.

export const EXPRESS_CHECKOUT_EVENT_PREFIX =
  "callback-payabli-function-expresscheckout-";

export function buildEventName(kind, randomId = "") {
  return `${EXPRESS_CHECKOUT_EVENT_PREFIX}${kind}${randomId}`;
}

export function postExpressCheckoutEvent({
  kind,
  randomId = "",
  data,
  target = "*",
} = {}) {
  if (typeof window === "undefined" || !window.parent) return;
  window.parent.postMessage(
    {
      event: buildEventName(kind, randomId),
      data,
    },
    target
  );
}

// Bridge between the iframe and the top-level host (public/component.js) for the
// Apple Pay third-party-browser flow, where the host owns the ApplePaySession so
// the QR renders at the top level instead of being trapped in this iframe.
// Correlated by randomId. The host hardcodes the same string format.
//
// kinds (iframe→host): "start" | "merchant-session" | "complete" | "abort"
//       (host→iframe):  "validate-merchant" | "authorized" | "cancel" | "error"
export const APPLE_PAY_BRIDGE_PREFIX = "callback-payabli-function-applepay-";

export function buildApplePayBridgeEvent(kind, randomId = "") {
  return `${APPLE_PAY_BRIDGE_PREFIX}${kind}${randomId}`;
}
